export class ProviderUserModel {
    id: any
    ownName: string = ''
    email: string = ''
    phone: string = ''
}